/* eslint-disable no-nested-ternary */
import { Article } from 'pleinchamp-api-client';
import React, { ComponentPropsWithRef, FC } from 'react';
import { ADVERT_FORMAT_ID } from '@adverts/business/Adverts.contants';
import { insertAdvertInArray } from '@adverts/business/adverts.utils';
import { PlcApiResponseInterface } from '@api/business/api.hook';
import { ContentCardLoader } from '@components/content/ContentCard/ContentCardLoader.component';
import { PlcMessageWithRetry } from '@components/PlcMessage/PlcMessageWithRetry.component';
import { Text } from '@components/Text/Text.component';
import { Breakpoint, useClassNames, useIsBreakpointDown } from '@styles/breakpoints';
import { buildContentCard } from '@utils/card';
import styles from './ReadAlso.module.scss';

type Props = ComponentPropsWithRef<'div'> & PlcApiResponseInterface<Article[]>;

const ReadAlso: FC<Props> = ({ data, isValidating, error, retryCallback }) => {
  const isMobile = useIsBreakpointDown(Breakpoint.s);
  const cards = data?.map((item) => buildContentCard(item, isMobile));
  const cardsWithAds = cards ? insertAdvertInArray(cards, 2, 4, ADVERT_FORMAT_ID.NativeAdBis) : null;

  const listClassName = useClassNames({
    all: [styles.readAlsoList, 'flex', 'column'],
    s: ['row', 'wrap', 'plc-neg-mx-s'],
  });
  return (
    <div className="read-also plc-mb-up-s-l">
      <Text className="plc-mb-m" i18nKey="common.read-also" tag="p" variant="p-style-h3" />
      <div className={listClassName}>
        {isValidating ? (
          <>
            <ContentCardLoader uniqueKey="readAlso1" />
            <ContentCardLoader uniqueKey="readAlso2" />
          </>
        ) : error ? (
          <PlcMessageWithRetry retryCallback={retryCallback} />
        ) : (
          cardsWithAds
        )}
      </div>
    </div>
  );
};

export default ReadAlso;
